var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-button',{attrs:{"outlined":"","block":"","flat":false,"to":_vm.addEventUrl}},[_c('v-icon',{staticClass:"mr-1",attrs:{"icon":"today"}}),_vm._v(" Add to Calendar ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }